<template>
  <v-form ref="addrForm" v-model="valid" class="address ml-4" >
            <v-text-field
              color="accent"
              label="Street"
              name="Street"
              v-model=street
              @input="change()"
              @blur="change()"
              :rules="streetRules"
              placeholder="Address">
            </v-text-field>

            <v-layout wrap>
              <v-flex class="sm6 xs12">
                <v-text-field
                  color="accent"
                  label="City"
                  v-model=city
                  placeholder="City"
                  style="flex:4"
                  :rules="cityRules"
                  @input="change()"
                  @blur="change()"
                  ></v-text-field>
              </v-flex>

              <v-flex class="sm3 xs6">
                <v-select
                    color="accent"
                    :items="states"
                    label="State"
                    v-model="state"
                    style="flex:1"
                    :rules="stateRules"
                    class="ml-2 mr-2"
                    @change="stateChanged"
                  ></v-select>
              </v-flex>
              <v-flex class="sm3 xs6">
                <v-text-field
                    color="accent"
                    type=string
                    label="ZIP"
                    v-model=zip5
                    style="flex:1;"
                    :rules="zipRules"
                    @input="change()"
                    @blur="change()"
                    placeholder="ZIP">
                 </v-text-field>
               </v-flex>
           </v-layout>
  </v-form>
</template>

<script>
import utils from '../../utils.ts'

export default {
  name: 'Address',
  props: ['value'],
  data: function () {
    return {
      valid: false,
      states: utils.listofstates,
      city: null,
      state: null,
      zip5: null,
      zip4: null,
      street: null,
      streetRules: [
        utils.required('Street is required'),
      ],
      cityRules: [
        utils.required('City is required'),
      ],
      zipRules: [
        utils.required('ZIP is required'),
        utils.isValidZIP('ZIP must be XXXXX or XXXXX-XXXX'),
        // length
        // format
      ],
      stateRules: [
        utils.isValidStateCode('State is invalid')
      ]

    }
  },
  computed: {
  },
  watch: {
    value: function (newVal) {
      // Copy it in from props
      this.city = newVal.city || null
      this.state = newVal.state || null
      this.zip5 = newVal.zip5 || null
      this.zip4 = newVal.zip4 || null
      this.street = newVal.street || null
    }
  },
  mounted: function () {
    // Copy it in from props
    this.city = this.value.city || null
    this.state = this.value.state || null
    this.zip5 = this.value.zip5 || null
    this.zip4 = this.value.zip4 || null
    this.street = this.value.street || null
  },
  methods: {
    stateChanged: function (event) {
      // console.log("State change: "+event)
      this.state = event
      this.change()
    },
    change: function () {
      const newAddress = {
        city: this.city,
        state: this.state,
        zip5: this.zip5,
        zip4: this.zip4,
        street: this.street,
        isValid: this.$refs.addrForm.validate()
      }
      this.$emit('input', newAddress)
    },
    isValid: function () {
      return this.$refs.addrForm.validate()

    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
